import styled from "styled-components";
import activityPlacesIcon from "../../../images/activity-places-icon.svg";
import dropDownIcon from "../../../images/dropdownIcon.svg";
import searchIcon from "../../../images/search-icon-grey.svg";
import loader from "../../../images/loading-spinner.svg";

export const HeaderContainer = styled.header`
  width: 100%;
  height: 3.125rem;

  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Logo = styled.img`
  display: block;
  height: 100%;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const ActivityPlacesIcon = styled.div`
  width: 1.25rem;
  height: 1.25rem;

  background-image: url(${activityPlacesIcon});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;

export const HeaderSelect = styled.div`
  height: 100%;

  padding: 0 0.5rem 0 0.6rem;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1rem;
  border-right: 0.0625em solid #dfdfdf;

  cursor: pointer;
`;
export const Selected = styled.div`
  font-size: 1.2rem;
  color: #484848;
  font-weight: 400;
  margin: 0 1rem 0 0.8rem;
  width: 5rem;
  user-select: none;
`;

export const DropdownIcon = styled.div`
  width: 0.7rem;
  height: 0.7rem;

  background-image: url(${dropDownIcon});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  ${props =>
    props.right
      ? "margin-left: 0.5rem;margin-top: 0.25rem;"
      : ""} transition: transform 0.1s linear;

  ${props => (props.open ? "transform: rotate(180deg)" : "")};
`;

export const List = styled.ul`
  padding: 0;
  margin: 0;

  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  width: 100%;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background-color: #ffffff;
  z-index: 1;
  list-style: none;

  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);

  max-height: 20rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 500;
`;
export const ListItem = styled.li`
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  color: #484848;
  cursor: pointer;
  &:hover {
    background-color: #f7f7f7;
  }
`;

export const SearchInputField = styled.input`
  font-size: 1rem;
  font-weight: 400;
  color: #484848;

  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;

  outline: none;
  text-indent: 2.2rem;

  border: none;

  background-color: #fff;

  background-image: url(${props => (props.loading ? loader : searchIcon)});

  background-size: 1.1rem 1.1rem;
  background-repeat: no-repeat;
  background-position: 0.7rem center;

  transition: border 0.3s ease-in-out;

  &:required {
    box-shadow: none;
  }

  &:placeholder {
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
  }
  &::-webkit-input-placeholder {
    /* Chrome */
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
    transition: opacity 0.3s ease-in-out;
  }
  &:focus::-webkit-input-placeholder {
    opacity: 0.5;
  }
  &:-ms-input-placeholder {
    /* IE 10+ */
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
    transition: opacity 0.3s ease-in-out;
  }
  &:focus:-ms-input-placeholder {
    opacity: 0.5;
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
    transition: opacity 0.3s ease-in-out;
  }
  &:focus::-moz-placeholder {
    opacity: 0.5;
  }
  &:-moz-placeholder {
    /* Firefox 4 - 18 */
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
    transition: opacity 0.3s ease-in-out;
  }
  &:focus:-moz-placeholder {
    opacity: 0.5;
  }
  &:disabled::-webkit-input-placeholder {
    color: #dfdfdf;
  }
  &:disabled:-ms-input-placeholder {
    color: #dfdfdf;
  }
  &:disabled::-moz-placeholder {
    color: #dfdfdf;
  }
  &:disabled:-moz-placeholder {
    color: #dfdfdf;
  }

  &:disabled:placeholder {
    color: #dfdfdf;
  }
`;

export const SearchResultContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const Link = styled.a`
  color: #484848;
  text-decoration: none;
  background-color: transparent;
  width: 100%;
  height: 100%;
  display: block;
  font-size: 1rem;
  &:hover {
    color: #484848;
    text-decoration: none;
    background-color: transparent;
  }
`;

// export const NavBar = styled.nav`
//   height: 100%;
//   display: flex;
//   justify-content: flex-end;
//   align-items: center;
// `;

export const NavContainer = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  height: 100%;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 1rem;
`;

export const NavItem = styled.li`
  height: 100%;
  padding: 0 ${props => (props.dropdown ? "0" : "0.5rem")};
  font-size: 0.875rem;
  color: #484848;

  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;

  user-select: none;
  border-bottom: ${props => (props.dropdown ? "none" : "2px solid transparent")};
  cursor: pointer;
  &:hover {
    border-bottom-color: #33cc99;
  }
`;

export const NavIcon = styled.div`
  height: 0.875rem;
  width: 0.875rem;
  margin-right: 0.3rem;
  ${props => (props.right ? "margin-left: 0.4rem" : "")}
  background-image: url(${props => props.icon});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;
export const NavBarBadge = styled.div`
  height: 1.2rem;
  width: 1.2rem;

  font-size: 0.7rem;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;

  background-color: #33cc99;
  border-radius: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.3rem;
`;
